import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { homeFaqs as faqs } from '../data/faqs';
export function FAQ() {
  return <section className="w-full bg-black py-16 px-4 border-t border-zinc-900" id="faq" data-id="element-171" data-mp="1matemq09gq2n">
      <div className="max-w-4xl mx-auto" data-id="element-172" data-mp="1hdupklvgf9bb">
        <div className="text-center mb-12" data-id="element-173" data-mp="1cf057fhu9cp3">
          <h2 className="text-3xl sm:text-5xl md:text-6xl font-black uppercase mb-4" data-id="element-174" data-mp="1cg1epfj7hr4p">
            <span className="bg-clip-text text-transparent bg-gradient-to-b from-yellow-300 via-yellow-400 to-yellow-500" data-id="element-175" data-mp="2a0xkl40x91wt">
              Frequently Asked Questions About Mobile Detailing
            </span>
          </h2>
          <div className="h-1 w-24 bg-red-600 mx-auto rounded-full shadow-[0_0_10px_rgba(220,38,38,0.8)]" data-id="element-176" data-mp="2028156tdn9eg" />
          <p className="text-gray-400 text-lg max-w-2xl mx-auto mt-4" data-id="element-177" data-mp="1v72do3kbtmo9">
            Everything you need to know about our professional mobile auto
            detailing service in Los Angeles and Ventura County
          </p>
        </div>

        <dl className="space-y-4" data-id="element-178" data-mp="1kn72c5qyv1qi">
          {faqs.map((faq, index) => <motion.div key={faq.question} initial={{
          y: 20,
          opacity: 0
        }} whileInView={{
          y: 0,
          opacity: 1
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.35,
          ease: [0.23, 1, 0.32, 1],
          delay: Math.min(index, 4) * 0.05
        }} className="bg-zinc-900/40 border border-zinc-800 rounded-xl p-6" data-id="element-179" data-mp="1klnmgg982sp9" data-mpi={index}>
              <dt className="text-white font-bold text-lg" data-id="element-180" data-mp="16oh4gnwboy13">{faq.question}</dt>
              <dd className="mt-3 text-gray-300 text-base leading-relaxed" data-id="element-181" data-mp="rz2tjbd3m8jl">
                {faq.answer}
              </dd>
            </motion.div>)}
        </dl>

        <p className="text-center mt-8" data-id="element-182" data-mp="wynpre0vw2sm">
          <Link to="/faq" className="text-yellow-400 font-bold hover:text-yellow-300 transition-colors" data-id="element-183" data-mp="iyd2sm2p38cq">
            See all questions, pricing &amp; customer information &rarr;
          </Link>
        </p>
      </div>
    </section>;
}